import { PRIMARY_COLOR, SECONDARY_COLOR, FONT_COLOR } from './constants';

const theme = {
  primaryColor: PRIMARY_COLOR,
  secondaryColor: SECONDARY_COLOR,
  buttons: {
    primary: {
      active: {
        backgroundColor: PRIMARY_COLOR[0],
        color: '#ffffff',
        border: 'none',
        hoverColor: '#ffffff',
        hoverBackgroundColor: PRIMARY_COLOR[6],
        hoverBorder: 'none',
        focusColor: '#ffffff',
        focusBorder: 'none',
        focusOutline: PRIMARY_COLOR[7],
        focusBackgroundColor: PRIMARY_COLOR[7],
        cursor: 'pointer',
      },
      disabled: {
        backgroundColor: SECONDARY_COLOR[4],
        color: '#A6A6A6',
        border: 'none',
        cursor: 'not-allowed',
      },
    },
    secondary: {
      active: {
        backgroundColor: 'transparent',
        color: SECONDARY_COLOR[0],
        border: `1px solid ${SECONDARY_COLOR[0]}`,
        hoverColor: PRIMARY_COLOR[6],
        hoverBorder: `1px solid ${PRIMARY_COLOR[6]}`,
        hoverBackgroundColor: 'transparent',
        focusColor: PRIMARY_COLOR[7],
        focusBorder: `1px solid ${PRIMARY_COLOR[7]}`,
        focusOutline: PRIMARY_COLOR[7],
        focusBackgroundColor: 'transparent',
        cursor: 'pointer',
      },
      disabled: {
        backgroundColor: SECONDARY_COLOR[0],
        color: '#A6A6A6',
        border: 'none',
        cursor: 'not-allowed',
      },
    },
    alert: {
      active: {
        backgroundColor: '#B91C1C',
        color: '#FFFFFF',
        border: 'none',
        hoverColor: '#FFFFF',
        hoverBorder: 'none',
        hoverBackgroundColor: '#991B1B',
        focusColor: '#ffffff',
        focusBorder: 'none',
        focusOutline: '#7F1D1D',
        focusBackgroundColor: '#7F1D1D',
        cursor: 'pointer',
      },
      disabled: {
        backgroundColor: SECONDARY_COLOR[0],
        color: '#A6A6A6',
        border: 'none',
        cursor: 'not-allowed',
      },
    },
  },
  links: {
    primary: {
      color: PRIMARY_COLOR[0],
      hoverColor: FONT_COLOR,
      focusBorderColor: PRIMARY_COLOR[0],
      textDecoration: 'underline',
    },
    secondary: {
      color: FONT_COLOR,
      hoverColor: PRIMARY_COLOR[0],
      focusColor: PRIMARY_COLOR[6],
      focusBorderColor: PRIMARY_COLOR[0],
      textDecoration: 'underline',
    },
  },
};

export default theme;
